<template>
  <a class="telLink" :href="'tel:' + value">
    <template v-if="$slots.default">
      <slot></slot>
    </template>
    <template v-else>
      {{ value }}
    </template>
  </a>
</template>

<script>
export default {
    props: {
        value: {
            required: true,
            type: String
        }
    }
};
</script>
